import { FC } from 'react'

import { BLACK_COLOR } from '../../utils/constants'

const PageIcon: FC = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.8031 31.8977C20.013 31.8278 20.2107 31.7234 20.3876 31.5878L20.5858 31.4142L28 24V23C28 22.4477 27.5523 22 27 22H19.5H19H18.5C18.2239 22 18 22.2239 18 22.5V23V30H6C4.97433 30 4.12899 29.2279 4.01346 28.2332L4 28V4C4 2.97433 4.77208 2.12899 5.76676 2.01346L6 2H24C25.0257 2 25.871 2.77208 25.9865 3.76676L26 4V17C26 17.5523 26.4477 18 27 18C27.4909 18 27.8992 17.6462 27.9839 17.1798L28 17V4C28 1.89128 26.3682 0.16367 24.2985 0.0109711L24 0H6C3.89128 0 2.16367 1.63176 2.01097 3.70148L2 4V28C2 30.1087 3.63176 31.8363 5.70148 31.989L6 32H18.5H19.1716H19.5C19.614 32 19.719 31.9619 19.8031 31.8977ZM20 24H25.1716L20 29.1716V24Z"
      fill={BLACK_COLOR}
    />
    <rect
      width="8"
      height="2"
      rx="0.5"
      transform="matrix(1 0 0 -1 8 24.8008)"
      fill={BLACK_COLOR}
    />
    <rect
      width="14"
      height="2"
      rx="0.5"
      transform="matrix(1 0 0 -1 8 17.1992)"
      fill={BLACK_COLOR}
    />
    <rect
      width="14"
      height="2"
      rx="0.5"
      transform="matrix(1 0 0 -1 8 9.59961)"
      fill={BLACK_COLOR}
    />
  </svg>
)

export default PageIcon
